export default __webpack_public_path__ + "static/media/640_dummy2016-beauty02-de.6651348e.png";